import { render, staticRenderFns } from "./YouGotMailPage.vue?vue&type=template&id=250b7086&scoped=true&"
import script from "./YouGotMailPage.vue?vue&type=script&lang=js&"
export * from "./YouGotMailPage.vue?vue&type=script&lang=js&"
import style0 from "./YouGotMailPage.vue?vue&type=style&index=0&id=250b7086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250b7086",
  null
  
)

export default component.exports